export default "__VITE_ASSET__Sa52MFxA__"